import { DFPManager } from '@edmunds/react-dfp';
import { logger } from 'client/utils/logger/logger';

export const destroyPwtBids = {
  init: async (slotArray, googletag, refreshRule) => {
    /*
     * Invoked by pwtAdRefresher() in client/utils/pwt/ad-refresher.js
     * @params refreshRule: an Array of either slotId(from client/utils/pwt/ad-refresher.js) or refresh rule (from client/site-modules/shared/components/ad-unit/utils/scroll-ads-refresher.js)
     */
    const documentElement = document.documentElement;
    if (documentElement.scrollHeight <= documentElement.scrollTop + documentElement.clientHeight) return;
    destroyPwtBids.slotIds = slotArray.map(elem => elem.slotId);
    destroyPwtBids.slotArray = slotArray;
    destroyPwtBids.refreshRule.push(refreshRule);
    if (window.PWT && typeof window.PWT.removeKeyValuePairsFromGPTSlots === 'function') {
      window.PWT.initAdserverSet = false;

      // first remove already added OpenWrap targeting key value pairs from slots
      await window.PWT.removeKeyValuePairsFromGPTSlots(
        destroyPwtBids.getFilteredSlotIds(googletag.pubads().getSlots())
      );
      // now call OpenWrap to get bids and add respective key value pairs
      // destroyPwtBids.requestNewBid(window.googletag.pubads().getSlots());
      if (!destroyPwtBids.isInited) destroyPwtBids.requestNewBid(googletag.pubads().getSlots());
    } else {
      DFPManager.refresh(...destroyPwtBids.refreshRule);
    }
  },

  refreshRule: [],

  isInited: false,

  requestNewBid: pubadSlots => {
    destroyPwtBids.isInited = true;
    const filteredSlotIds = destroyPwtBids.getFilteredSlotIds(pubadSlots);
    const confForGPT =
      window.PWT && typeof window.PWT.generateConfForGPT === 'function'
        ? window.PWT.generateConfForGPT(filteredSlotIds)
        : [];
    const adSizeFilteredConfForGPT = destroyPwtBids.getAdSizeFilteredConf(confForGPT);
    if (window.PWT && typeof window.PWT.requestBids === 'function') {
      window.PWT.requestBids(adSizeFilteredConfForGPT, destroyPwtBids.onLoadCallback);
    }
  },

  onLoadCallback: adUnitsArray => {
    if (window.PWT && typeof window.PWT.addKeyValuePairsToGPTSlots === 'function') {
      window.PWT.addKeyValuePairsToGPTSlots(adUnitsArray);
    } else {
      logger.warn('Slots did not get key value pairs added properly');
    }
    DFPManager.refresh(...destroyPwtBids.refreshRule);
    destroyPwtBids.isInited = false;
    destroyPwtBids.refreshRule = [];
  },

  getFilteredSlotIds: slots => slots.filter(slot => destroyPwtBids.slotIds.includes(slot.getSlotElementId())),

  getAdSizeFilteredConf: configs =>
    configs.map((slot, index) => {
      const slotObj = slot;
      const { slotId, divId, adUnitId, adUnitIndex, sizes } = destroyPwtBids.slotArray[index];
      slotObj.code = slotId;
      slotObj.divId = divId;
      slotObj.adUnitId = adUnitId;
      slotObj.adUnitIndex = adUnitIndex;
      slotObj.sizes = sizes;
      slotObj.mediaTypes.banner.sizes = sizes;
      return slotObj;
    }),
};
